import { DemoUserObject } from "assets/data/usersData";
import AddMembersModal from "components/files/modals/AddMembersModal";
import FeedLayout from "layouts/files/FeedLayout";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { BasicCheckbox, Button, Input, RoundCheckBox, SVG, ToolTip } from "ui";
import { profileBG, placeholder } from "utils/assets_exports/images";
import userIcon from "assets/img/user_icon.png";
const CreateCommunity = () => {
    const profileImgInputRef = useRef(null);
    const coverImgInputRef = useRef(null);
    const [profilePic, setProfilePic] = useState(placeholder);
    const [cover, setCover] = useState(profileBG);

    const handleSetProfile = (file: FileList | null) => {
        if (!file) {
            return;
        }
        setProfilePic(URL.createObjectURL(file[0]));
    };
    const handleSetCover = (file: FileList | null) => {
        if (!file) {
            return;
        }
        setCover(URL.createObjectURL(file[0]));
    };

    // name and about
    const [name, setName] = useState("");
    const [about, setAbout] = useState("");

    // discoverability
    const [listed, setListed] = useState(true);

    // permissions
    const [rule1, setRule1] = useState(false);
    const [rule2, setRule2] = useState(false);

    const toggleRule1 = () => {
        if (rule1) {
            console.log("fuck youuu");
            setRule1(false);
        } else {
            console.log("fuck touuu");
            setRule1(true);
        }
    };
    const toggleRule2 = () => {
        if (rule2) {
            setRule2(false);
        } else {
            setRule2(true);
        }
    };

    // members
    const [openMembersModal, setOpenMembersModal] = useState(false);
    const [members, setMembers] = useState<DemoUserObject[]>([]);
    const removeMember = (user: DemoUserObject) => {
        if (members.includes(user)) {
            const newArr = members.filter((u) => u != user);
            setMembers(newArr);
        }
    };

    return (
        <>
            <FeedLayout pageTitle="Communities">
                <div className=" w-full">
                    <Link
                        to="/communities"
                        className="d-flex flex-j-start flex-a-center gap-5 mb-10"
                    >
                        <SVG svg="arrow-left" size={18} />

                        <span className="momeento-p white-text black-text">
                            Back to Communities list
                        </span>
                    </Link>
                </div>
                <div className="cover-bg">
                    <img className="cover-image" src={cover} alt="" />
                    <div className="avatar">
                        <img
                            id="user-avatar"
                            className="avatar-image"
                            src={profilePic}
                            alt=""
                        />
                        <div
                            className="avatar-button p-relative"
                            onClick={() =>
                                (
                                    profileImgInputRef.current as unknown as HTMLInputElement
                                ).click()
                            }
                        >
                            <input
                                type="file"
                                ref={profileImgInputRef}
                                className="d-none"
                                onChange={(e) =>
                                    handleSetProfile(e.target.files)
                                }
                            />
                            <i className="mdi mdi-camera"></i>
                        </div>
                    </div>
                    <div className="cover-overlay"></div>
                    <div
                        className="cover-edit modal-trigger p-relative"
                        data-modal="change-cover-modal"
                        onClick={() =>
                            (
                                coverImgInputRef.current as unknown as HTMLInputElement
                            ).click()
                        }
                    >
                        <input
                            type="file"
                            // className="hidden-input cursor-pointer"
                            className="d-none"
                            ref={coverImgInputRef}
                            onChange={(e) => handleSetCover(e.target.files)}
                        />
                        <i className="mdi mdi-camera"></i>
                        <span className="cursor-pointer">Add cover image</span>
                    </div>
                    {/* <!--/html/partials/pages/profile/timeline/dropdowns/timeline-mobile-dropdown.html-->
        {{> timeline-mobile-dropdown}} */}
                </div>

                <div className="community-info community-info-fields card">
                    {/* name */}
                    <Input
                        label="Community Name"
                        value={name}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setName(e.target.value)}
                        // error={nameError}
                        placeHolder="community name..."
                    />
                    {/* about */}
                    <Input
                        label="About Community"
                        value={about}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setAbout(e.target.value)}
                        // error={nameError}
                        placeHolder="community is about..."
                    />
                    <div className="field">
                        <div className="d-flex flex-j-between flex-a-center mb-20">
                            <label>Add Members</label>
                            <span
                                className="plus-btn cursor-pointer d-flex flex-a-center"
                                onClick={() => setOpenMembersModal(true)}
                            >
                                <SVG
                                    svg="plus-circle"
                                    size={24}
                                    className="blue-svg"
                                />
                            </span>
                        </div>
                        <div className="community-form-members-list d-flex flex-j-start flex-a-start gap-10 mb-20">
                            {members.map((m) => (
                                <div className="member-sm-card community-list-request-img p-relative">
                                    <img
                                        src={m.url || userIcon}
                                        alt={m.username}
                                    />
                                    <div className="float-x">
                                        <span
                                            className="close-modal"
                                            onClick={() => removeMember(m)}
                                            // onClick={() => setOpen(false)}
                                        >
                                            <SVG svg="x" size={16} />
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* discoverability */}
                    <div className="field">
                        <div className="d-flex flex-j-between flex-a-center mb-20">
                            <label>Group Discoverbility</label>
                        </div>
                        <div className="d-flex flex-col flex-j-start flex-a-start gap-10 mb-20">
                            <div className="discover-item d-flex flex-j-start flex-a-center gap-10">
                                <RoundCheckBox
                                    name="discoverability"
                                    text="Listed"
                                    color=""
                                    checked={listed}
                                    handleClick={() => setListed(true)}
                                />
                                <p className="momeento-p">Listed</p>
                                <ToolTip text="Community appers in search results and is visible to other on members profiles" />
                            </div>
                            <div className="discover-item d-flex flex-j-start flex-a-center gap-10">
                                <RoundCheckBox
                                    name="discoverability"
                                    text="Un Listed"
                                    color=""
                                    checked={!listed}
                                    handleClick={() => setListed(false)}
                                />
                                <p className="momeento-p">Unlisted</p>
                                <ToolTip text="Community dose not appers in search" />
                            </div>
                        </div>
                    </div>

                    {/* Permission */}
                    <div className="field">
                        <div className="d-flex flex-j-between flex-a-center mb-20">
                            <label>Permission</label>
                        </div>
                        <div className="d-flex flex-col flex-j-start flex-a-start gap-10 mb-20">
                            <div className="discover-item d-flex flex-j-start flex-a-center gap-10">
                                <BasicCheckbox
                                    name="permission"
                                    text="Allow members to Invited their Followers"
                                    color=""
                                    checked={rule1}
                                    // handleClick={() => setRule1(() => !rule1)}
                                    handleClick={toggleRule1}
                                    className="is-not-round"
                                />
                                <p className="momeento-p">
                                    Allow members to Invited their Followers
                                </p>
                                <ToolTip text="If disabled, only group admins will be invite 1st degree connections to the group. All requests to join will still require admin approval" />
                            </div>
                            <div className="discover-item d-flex flex-j-start flex-a-center gap-10">
                                <BasicCheckbox
                                    name="permission"
                                    text="Require new Posts or Incidents by to reviewd by admins"
                                    color=""
                                    checked={rule2}
                                    handleClick={toggleRule2}
                                    className="is-not-round"
                                />
                                <p className="momeento-p">
                                    Require new Posts or Incidents by to reviewd
                                    by admins
                                </p>
                                <ToolTip text="If enabled, members posts will require admin approval before they become visible to others." />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-j-center flex-a-center w-full">
                        <Button text="Save" rounded />
                    </div>
                </div>
            </FeedLayout>
            <AddMembersModal
                members={members}
                setMembers={setMembers}
                open={openMembersModal}
                setOpen={setOpenMembersModal}
            />
        </>
    );
};
export default CreateCommunity;
